import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Close as CloseIcon } from "@mui/icons-material";
import PropTypes from "prop-types";

import "../pubvision/AssetsGeneration.css";

const PostDialog = ({
  open,
  onClose,
  postSection,
  setPostSection,
  postContentLevel,
  setPostContentLevel,
  postSelectedColor,
  setPostSelectedColor,
  postCustomColor,
  setPostCustomColor,
  onStartGeneratingPost,
}) => {
  const sectionOptions = [
    "Introduction",
    "Abstract",
    "Adverse events",
    "Safety",
    "Results",
    "Inclusion exclusion criteria",
    "Study design",
    "Discussion",
    "Key findings",
    "conclusions",
  ];

  const enabledSections = [
    "Introduction",
    "Abstract",
    "Adverse events",
    "Results",
  ];

  const handleColorClick = (color) => {
    setPostSelectedColor(color);
    setPostCustomColor("");
  };

  const handleCustomColorClick = () => setPostSelectedColor("custom");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="abstract-video-dialog"
      sx={{
        "& .MuiBackdrop-root": { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        "& .MuiPaper-root": { fontFamily: "'Inter', sans-serif" },
        "& *": { fontFamily: "'Inter', sans-serif !important" },
      }}
    >
      <DialogTitle className="dialog-title">
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="close-button"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogTitle className="dialog-title main-title">
        <strong>Post : Enter requirements below</strong>
      </DialogTitle>
      <div className="dialog-subtitle-container">
        <p className="dialog-subtitle">
          Please fill the form below to get the post as per your requirement
        </p>
      </div>
      <DialogContent className="dialog-content">
        <div className="dialog-field">
          <label className="dialog-label" htmlFor="post-section">
            Select the section you want to include in the Post
          </label>
          <RadioGroup
            id="post-section"
            value={postSection}
            onChange={(e) => setPostSection(e.target.value)}
          >
            {sectionOptions.map((option) => {
              const disabled = !enabledSections.includes(option);
              return (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={<Radio />}
                  label={option}
                  disabled={disabled}
                  sx={disabled ? { opacity: 0.5 } : {}}
                />
              );
            })}
          </RadioGroup>
        </div>
        <div className="dialog-field">
          <label className="dialog-label" htmlFor="post-content-level">
            Choose the post content understanding level
          </label>
          <Select
            id="post-content-level"
            value={postContentLevel}
            onChange={(e) => setPostContentLevel(e.target.value)}
            className="language-dropdown"
          >
            <MenuItem value="Beginner" disabled style={{ opacity: 0.5 }}>
              Beginner
            </MenuItem>
            <MenuItem value="Moderate">Moderate</MenuItem>
            <MenuItem value="Expert" disabled style={{ opacity: 0.5 }}>
              Expert
            </MenuItem>
          </Select>
        </div>
        <div className="dialog-field">
          <label className="dialog-label" htmlFor="post-brand-colors">
            Choose the Post brand color
          </label>
          <div className="color-theme-container" id="post-brand-colors">
            <div className="color-options">
              {[
                "#796eff",
                "#009688",
                "#2427a7",
                "#1E4DE3",
                "#8bc34a",
                "#00bcd4",
                "#9c27b0",
              ].map((color) => (
                <div
                  key={color}
                  className={`color-circle ${postSelectedColor === color ? "selected" : ""
                    }`}
                  style={{ backgroundColor: color, opacity: 0.5, pointerEvents: "none" }}
                  onClick={() => handleColorClick(color)}
                />
              ))}
            </div>
            <div className="custom-color-wrapper">
              <div
                className={`custom-color-box ${postSelectedColor === "custom" ? "selected" : ""
                  }`}
                onClick={handleCustomColorClick}
                style={{ opacity: 0.5, pointerEvents: "none" }}
              >
                Custom
              </div>
              {postSelectedColor === "custom" && (
                <input
                  type="text"
                  className="custom-color-input"
                  placeholder="#FFFFFF"
                  value={postCustomColor}
                  onChange={(e) => setPostCustomColor(e.target.value)}
                />
              )}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} variant="text" className="cancel-btn">
          Cancel
        </Button>
        <Button
          onClick={onStartGeneratingPost}
          variant="contained"
          className="start-generating-btn"
        >
          Start Generating
        </Button>
      </DialogActions>
    </Dialog>
  );
};
PostDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  postSection: PropTypes.string.isRequired,
  setPostSection: PropTypes.func.isRequired,
  postContentLevel: PropTypes.string.isRequired,
  setPostContentLevel: PropTypes.func.isRequired,
  postSelectedColor: PropTypes.string.isRequired,
  setPostSelectedColor: PropTypes.func.isRequired,
  postCustomColor: PropTypes.string.isRequired,
  setPostCustomColor: PropTypes.func.isRequired,
  onStartGeneratingPost: PropTypes.func.isRequired,
};

export default PostDialog;
